import type { ProjectDetail, RemovalActionType } from "../types";

export function getAvailableRemovalActions(detail: ProjectDetail): RemovalActionType[] {
  if (detail.is_default) return [];
  const actions: RemovalActionType[] = [];
  if (detail.can_archive) actions.push("archive");
  if (detail.can_hard_delete) actions.push("delete");
  return actions;
}
